import { Inject, Injectable } from '@angular/core';
import { AccountGroupSdkService, AggregationSupportedFields } from '@vendasta/account-group';
import { combineLatest, Observable, ReplaySubject } from 'rxjs';
import { shareReplay, switchMap, take } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class TagService {
  private tags$$: ReplaySubject<string[]> = new ReplaySubject<string[]>();
  private _tags$: Observable<string[]> = this.tags$$.asObservable();

  constructor(
    @Inject('PARTNER_ID') private readonly partnerId$: Observable<string>,
    @Inject('MARKET_ID') private readonly marketId$: Observable<string>,
    private accountGroupService: AccountGroupSdkService,
  ) {}

  get tags(): Observable<string[]> {
    return this._tags$;
  }

  loadAllTags(): void {
    combineLatest([this.partnerId$, this.marketId$])
      .pipe(
        take(1),
        switchMap(([partnerId, marketId]) => {
          return this.accountGroupService.listOptionsForField({
            partnerId: partnerId,
            marketId: marketId,
            field: AggregationSupportedFields.AGGREGATION_TAGS,
          });
        }),
        shareReplay(1),
      )
      .subscribe((tags) => this.tags$$.next(tags));
  }
}
